import {
  FETCH_ALL,
  FETCH_BY_SEARCH,
  FETCH_THEME,
  CREATE,
  UPDATE,
  DELETE,
  LIKE,
  FETCH_THEME_BY_ID,
  GET_STYLES
} from '../types';



export default (state = { isLoading: true, themes: [] }, action) => {
  switch (action.type) {
    case 'START_LOADING':
      return { ...state, isLoading: true };
    case 'END_LOADING':
      return { ...state, isLoading: false };
    case FETCH_ALL:
      return {
        ...state,
        themes: action.payload.data,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_BY_SEARCH:
      return { ...state, themes: action.payload.data };
    case FETCH_THEME:
      return action.payload;
    case FETCH_THEME_BY_ID:
      return action.payload;
    case LIKE:
      return {
        ...state,
        themes: state.themes.map((theme) =>
          theme._id === action.payload._id ? action.payload : theme
        ),
      };
    case CREATE:
      return { ...state, themes: [...state.themes, action.payload] };
    case UPDATE:
      return {
        ...state,
        themes: state.themes.map((theme) =>
          theme._id === action.payload._id ? action.payload : theme
        ),
      };
    case DELETE:
      return {
        ...state,
        themes: state.themes.filter((theme) => theme._id !== action.payload),
      };
    default:
      return state;
  }
};
